.page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - var(--kh-topbar-height, 52px));
}

.header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 24px;
  background: var(--kh-surface);
  border-bottom: 1px solid var(--kh-border);
}

.back {
  color: var(--kh-text-secondary);
  text-decoration: none;
  font-weight: 500;
}
.back:hover {
  color: var(--kh-red);
  text-decoration: underline;
}

.title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--kh-text-primary);
  letter-spacing: var(--kh-ls-heading);
}

.muted {
  color: var(--kh-text-muted);
  font-size: var(--kh-size-meta);
}

.error {
  color: var(--kh-red);
  font-size: var(--kh-size-meta);
}

.body {
  flex: 1;
  display: flex;
  min-height: 0;
}

.canvas {
  flex: 1;
  min-width: 0;
  background: var(--kh-off-white);
}
